/**
 * <s-review-form data-endpoint data-shop-domain data-product-id data-product-url>
 * Wraps a review <form>; submits it to Judge.me's public review endpoint and
 * swaps in the success or error message ([data-state="success"|"error"]).
 */
class ReviewFormElement extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[type="submit"]');
    this.onSubmit = (event) => this.#submit(event);
    this.form?.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
  }

  #show(state) {
    this.querySelectorAll('[data-state]').forEach((el) => {
      el.hidden = el.dataset.state !== state;
    });
  }

  async #submit(event) {
    event.preventDefault();
    if (!this.form.reportValidity()) return;
    const data = new FormData(this.form);
    const payload = {
      shop_domain: this.dataset.shopDomain,
      platform: 'shopify',
      id: Number(this.dataset.productId),
      url: this.dataset.productUrl,
      name: String(data.get('name') || '').trim(),
      email: String(data.get('email') || '').trim(),
      rating: Number(data.get('rating')),
      title: String(data.get('title') || '').trim(),
      body: String(data.get('body') || '').trim(),
    };
    this.submitButton?.setAttribute('aria-disabled', 'true');
    this.#show('');
    try {
      const response = await fetch(this.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error(String(response.status));
      this.form.reset();
      this.form.hidden = true;
      this.#show('success');
    } catch (error) {
      this.#show('error');
    } finally {
      this.submitButton?.removeAttribute('aria-disabled');
    }
  }
}

if (!customElements.get('s-review-form')) customElements.define('s-review-form', ReviewFormElement);
